import React from 'react';
import { ArrowLeft } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';
import { OptionsPageShell } from '../../components/options/OptionsPageShell';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

const LOGO_VERTICAL = 'https://customer-assets.emergentagent.com/job_chart-analyzer-107/artifacts/zc7oaxip_brain%20%2B%20GENICERTO.png';
const LOGO_PUREBRAIN = 'https://customer-assets.emergentagent.com/job_chart-analyzer-107/artifacts/gtg4vc6a_purebrain.png';

export default function OptionsAbout() {
  const { t } = useOptionsLocale();
  const navigate = useNavigate();

  return (
    <OptionsPageShell hideHeader>
      <div className="min-h-[calc(100vh-180px)] w-full" data-testid="options-about-page">
        <div className="w-full max-w-[680px] mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8 group"
            data-testid="options-about-back-button"
          >
            <ArrowLeft size={20} weight="bold" className="group-hover:-translate-x-1 transition-transform" />
            <span className="text-sm font-medium">{t('common.back')}</span>
          </button>

          <div className="flex flex-col items-center text-center pt-4 md:pt-8 mb-12" data-testid="options-about-hero">
            <img
              src={LOGO_VERTICAL}
              alt="GENI"
              className="h-24 md:h-28 lg:h-32 w-auto object-contain mb-6"
              data-testid="options-about-logo"
            />

            <h1
              className="text-3xl md:text-5xl font-black font-heading tracking-tight text-white mb-4"
              data-testid="options-about-title"
            >
              {t('aboutInstitutional.title')}
            </h1>

            <p className="text-white/55 max-w-2xl text-base md:text-lg" data-testid="options-about-byline">
              {t('aboutInstitutional.byline')}
            </p>
          </div>

          <div className="space-y-12" data-testid="options-about-content">
            <section data-testid="options-about-intro-section">
              <p className="text-xl text-white/90 leading-relaxed" data-testid="options-about-intro-text">
                {t('aboutInstitutional.geniParagraph1')}
              </p>
            </section>

            <section data-testid="options-about-geni-section">
              <p className="text-white/72 leading-[1.85] text-base" data-testid="options-about-geni-paragraph-2">
                {t('aboutInstitutional.geniParagraph2')}
              </p>
            </section>

            <section data-testid="options-about-mission-section">
              <p className="text-white/72 leading-[1.85] text-base" data-testid="options-about-geni-paragraph-3">
                {t('aboutInstitutional.geniParagraph3')}
              </p>
            </section>

            <section className="space-y-5" data-testid="options-about-options-section">
              <h2 className="text-xl md:text-2xl font-bold text-white tracking-tight" data-testid="options-about-options-heading">
                {t('aboutInstitutional.optionsHeading')}
              </h2>
              <p className="text-white/85 leading-[1.85] text-base" data-testid="options-about-options-paragraph-1">
                {t('aboutInstitutional.optionsParagraph1')}
              </p>
              <p className="text-white/72 leading-[1.85] text-base" data-testid="options-about-options-paragraph-2">
                {t('aboutInstitutional.optionsParagraph2')}
              </p>
              <p className="text-white/72 leading-[1.85] text-base" data-testid="options-about-options-paragraph-3">
                {t('aboutInstitutional.optionsParagraph3')}
              </p>
            </section>
          </div>

          <div className="flex items-center justify-center gap-2 mt-16 mb-6 text-sm text-white/40" data-testid="options-about-footer-branding">
            <img
              src={LOGO_PUREBRAIN}
              alt="GENI"
              className="h-5 w-auto object-contain opacity-80"
              data-testid="options-about-footer-logo"
            />
            <span data-testid="options-about-footer-text">GENI</span>
          </div>
        </div>
      </div>
    </OptionsPageShell>
  );
}